module.exports = __webpack_public_path__ + "img/pencairan_tab.16220893.png";